import React from 'react'
import { useSelector } from 'react-redux';
import styles from "../../../Pages/OptionsBoard/OptionsBoardStyles";
import { Table, TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core';
import AdminAccessBarChart from './AdminAccessBarChart';
import AdminAccessTableBody from './AdminAccessTableBody';

const AdminAccessTable = ({ chartData, chartOptionsMobile, chartOptions, barData, order, orderBy, localOD, sortData }) => {
    /** @type {import('../../../typings').IStateReducerState} */
    const { isMobile } = useSelector(state => state.appReducer);
    return (
        <div>
            <AdminAccessBarChart chartData={chartData} chartOptionsMobile={chartOptionsMobile} barData={barData} chartOptions={chartOptions} />
            <div
                style={{ ...styles.boardModalTableContainer, width: "100%" }}>
                <Table>
                    <TableHead>
                        <TableRow style={styles.tableRow}>
                            <TableCell
                                style={{ ...styles.modalTableHeaderCell, padding: 0 }}
                                className='sticky'
                                align='right'>
                                <TableSortLabel
                                    style={{ color: "#Fff" }}
                                    active={orderBy === "time"}
                                    direction={orderBy === "time" ? order : "asc"}
                                    onClick={() => sortData("time")}>
                                    Time
                                </TableSortLabel>
                            </TableCell>
                            <TableCell
                                style={{ ...styles.modalTableHeaderCell, padding: 0 }}
                                className='sticky'
                                align='right'>
                                <TableSortLabel
                                    style={{ color: "#Fff" }}
                                    active={orderBy === "volume"}
                                    direction={orderBy === "volume" ? order : "asc"}
                                    onClick={() => sortData("volume")}>
                                    {isMobile ? "Vol" : "Volume"}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell
                                style={{ ...styles.modalTableHeaderCell, padding: 0 }}
                                className='sticky'
                                align='right'>
                                <TableSortLabel
                                    style={{ color: "#Fff" }}
                                    active={orderBy === "vwap"}
                                    direction={orderBy === "vwap" ? order : "asc"}
                                    onClick={() => sortData("vwap")}>
                                    {isMobile ? "Prem" : "Premium"}
                                </TableSortLabel>
                            </TableCell>
                            {!isMobile && (
                                <TableCell
                                    style={styles.modalTableHeaderCell}
                                    className='sticky'
                                    align='right'>
                                    <TableSortLabel
                                        style={{ color: "#Fff" }}
                                        active={orderBy === "bidside"}
                                        direction={orderBy === "bidside" ? order : "asc"}
                                        onClick={() => sortData("bidside")}>
                                        Bid%
                                    </TableSortLabel>
                                </TableCell>
                            )}
                            {!isMobile && (
                                <TableCell
                                    style={styles.modalTableHeaderCell}
                                    className='sticky'
                                    align='right'>
                                    <TableSortLabel
                                        style={{ color: "#Fff" }}
                                        active={orderBy === "askside"}
                                        direction={orderBy === "askside" ? order : "asc"}
                                        onClick={() => sortData("askside")}>
                                        Ask%
                                    </TableSortLabel>
                                </TableCell>
                            )}
                            <TableCell
                                style={{ ...styles.modalTableHeaderCell, padding: 0 }}
                                className='sticky'
                                align='right'>
                                <TableSortLabel
                                    style={{ color: "#Fff" }}
                                    active={orderBy === "spot"}
                                    direction={orderBy === "spot" ? order : "asc"}
                                    onClick={() => sortData("spot")}>
                                    {isMobile ? "Stk" : "StkRef"}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell
                                style={{ ...styles.modalTableHeaderCell, padding: 0 }}
                                className='sticky'
                                align='right'>
                                <TableSortLabel
                                    style={{ color: "#Fff" }}
                                    active={orderBy === "ivol"}
                                    direction={orderBy === "ivol" ? order : "asc"}
                                    onClick={() => sortData("ivol")}>
                                    IV
                                </TableSortLabel>
                            </TableCell>
                            <TableCell
                                style={{
                                    ...styles.modalTableHeaderCell,
                                    padding: 0,
                                    width: "30px",
                                }}
                                className='sticky'
                                align='right'>
                                <TableSortLabel
                                    style={{ color: "#Fff" }}
                                    active={orderBy === "complex"}
                                    direction={orderBy === "complex" ? order : "asc"}
                                    onClick={() => sortData("complex")}>
                                    {isMobile ? "Sprd" : "Spreads"}
                                </TableSortLabel>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <AdminAccessTableBody localOD={localOD} orderBy={orderBy} order={order} />
                </Table>
            </div>
        </div>
    )
}

export default AdminAccessTable


// WEBPACK FOOTER //
// ./src/components/Modals/VolumeModal/AdminAccessTable.jsx